export default function CallStatusBanner({ callState }) {
  if (!callState?.active) return null;
  return (
    <div style={{
      marginTop:16, padding:16, borderRadius:12, border:'1px solid #bfdbfe',
      background:'linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%)',
      display:'flex', alignItems:'center', gap:12
    }}>
      <span className="loading-spinner" />
      <div>
        <div style={{ fontWeight:700, color:'#1e3a8a' }}>Call in progress…</div>
        <div style={{ color:'#1e40af', fontSize:12 }}>Call ID: {callState.callId || '—'}</div>
      </div>
    </div>
  );
}
